import { Router } from "@angular/router";
import {
  LoadingController,
  ModalController,
  Platform,
  ToastController,
} from "@ionic/angular";
import { PrescricaoService } from "../../../services/prescricao.service";
import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import * as moment from "moment";
import { CalendarModal, CalendarModalOptions } from "ion2-calendar";

@Component({
  selector: "app-prescricoes-list-component",
  templateUrl: "./prescricoes-list-component.html",
  styleUrls: ["./prescricoes-list-component.scss"],
})
export class PrescricoesListComponent implements OnInit {
  isMobile = false;
  tipo = "todas";
  prescricoesList: any = [];
  prescricoesListFiltered: any = [];

  dtFim: any;
  dtInicio: any;
  conteudoRevelado = false;
  listaFiltroMedicamentos: any[] = [];
  listaFiltroCnes: any[] = [];
  listaFiltroMunicipios: any[] = [];
  filtrosSelecionados: any[] = [];

  emptyState = {
    imgUrl: "/assets/imgs/bg-medicamentos.svg",
    title: "Você ainda não tem nenhuma prescrição.",
    text: "Essa área é destinada a disponibilização de prescrições registradas na Rede Nacional de Dados em Saúde (RNDS).",
  };

  emptyStateAtivas = {
    imgUrl: "/assets/imgs/bg-medicamentos.svg",
    title: "Nenhuma das suas prescrições estão ativas.",
    text: "Essa área é destinada a disponibilização de prescrições registradas na Rede Nacional de Dados em Saúde (RNDS).",
  };

  emptyStateNaoReconhecida = {
    imgUrl: "/assets/imgs/bg-medicamentos.svg",
    title: "Nenhuma das suas prescrições estão Não reconhecida.",
    text: "Essa área é destinada a disponibilização de prescrições registradas na Rede Nacional de Dados em Saúde (RNDS).",
  };

  @Output() prescricaoClicked = new EventEmitter();

  constructor(
    public router: Router,
    private plt: Platform,
    private prescricaoService: PrescricaoService,
    private loadingCtrl: LoadingController,
    private modalCtrl: ModalController,
    private toastController: ToastController
  ) {
    if (
      this.plt.is("ios") ||
      this.plt.is("android") ||
      this.plt.is("cordova")
    ) {
      this.isMobile = true;
    }
  }

  async ngOnInit() {
    await this.loadData();
  }

  async loadData() {
    const loading = await this.loadingCtrl.create({
      cssClass: "superapp-loader",
      spinner: "crescent",
    });
    await loading.present();
    this.prescricoesList = await this.prescricaoService.getPrescricao();

    console.log(this.prescricoesList);
    this.loadSelectFilters();
    this.formatarConteudo(false);

    await loading.dismiss();
  }

  async loadSelectFilters() {
    this.prescricoesList.forEach((pres) => {
      pres.medicamentos.forEach((med) => {
        if (!this.listaFiltroMedicamentos.includes(med.nome)) {
          this.listaFiltroMedicamentos.push(med.nome);
        }
      });
      const cnes = `${pres.coCnes} - ${pres.nmEstabelecimento}`;
      if (!this.listaFiltroCnes.includes(cnes)) {
        this.listaFiltroCnes.push(cnes);
      }

      // if (
      //   !this.listaFiltroMunicipios.includes(
      //     `${med.municipio} / ${med.ufRetirada}`
      //   )
      // ) {
      //   this.listaFiltroMunicipios.push(`${med.municipio} / ${med.ufRetirada}`);
      // }
    });
  }

  formatarConteudo(hidden: boolean) {
    this.prescricoesListFiltered = this.prescricoesList.map((pres) => ({
      tipo: "PRESCRICOES",
      nome: "Prescrições",
      dtAtualizacao: pres.dataHoraPrescricao,
      estabelecimento: pres.nmEstabelecimento,
      dtPrescricao: pres.dataHoraPrescricao,
      profissional: pres.nmProfissional,
      crm: pres.crmProfissional,
      endereco: pres.endereco,
      medicamentos: pres.medicamentos,
      cnes: `${pres.coCnes} - ${pres.nmEstabelecimento}`,
    }));

    if (hidden) {
      this.prescricoesListFiltered = this.prescricoesListFiltered.slice(0, 3);
    }
  }

  revelarConteudo() {
    this.formatarConteudo(false);
    this.conteudoRevelado = true;
  }

  async filter(datas?: any) {
    if (datas) {
      this.dtInicio = datas.dtInicio;
      this.dtFim = datas.dtFim;
    }
    this.revelarConteudo();

    if (this.dtInicio && !moment(this.dtInicio, "DD/MM/YYYY").isValid()) {
      const toast = await this.toastController.create({
        message: "Data de início invalida!",
        position: "top",
        duration: 4000,
        cssClass: "toast-error",
      });
      await toast.present();
      this.dtInicio = null;
    }
    if (this.dtFim && !moment(this.dtFim, "DD/MM/YYYY").isValid()) {
      const toast = await this.toastController.create({
        message: "Data fim invalida!",
        position: "top",
        duration: 4000,
        cssClass: "toast-error",
      });
      await toast.present();
      this.dtFim = null;
    }

    if (this.dtInicio && this.dtFim) {
      this.prescricoesListFiltered = this.prescricoesListFiltered.filter(
        (atendimento) => {
          const dtAtendimento = moment(
            atendimento.dtAtualizacao,
            "DD/MM/YYYY hh:mm"
          );
          const dtInicio = moment(this.dtInicio, "DD/MM/YYYY").subtract(1, "d");
          const dtFim = moment(this.dtFim, "DD/MM/YYYY").add(1, "d");

          return dtAtendimento.isBetween(dtInicio, dtFim);
        }
      );
    }

    if (this.filtrosSelecionados.length) {
      const medFiltrosSelecionados = this.filtrosSelecionados
        .filter((filter) => filter.tipo === "medicamento")
        .map((filter) => filter.data);
      const cnesFiltrosSelecionados = this.filtrosSelecionados
        .filter((filter) => filter.tipo === "cnes")
        .map((filter) => filter.data);

      const ufFiltrosSelecionados = this.filtrosSelecionados
        .filter((filter) => filter.tipo === "municipio_uf")
        .map((filter) => filter.data.split(" / ")[1]);
      const municipiosFiltrosSelecionados = this.filtrosSelecionados
        .filter((filter) => filter.tipo === "municipio_uf")
        .map((filter) => filter.data.split(" / ")[0]);

      this.prescricoesListFiltered = this.prescricoesListFiltered.filter(
        (pres) => {
          let count = 0;
          if (medFiltrosSelecionados.length) {
            pres.medicamentos.forEach((med) => {
              if (medFiltrosSelecionados.includes(med.nome)) {
                count += 1;
              }
            });
          }
          if (cnesFiltrosSelecionados.length) {
            if (cnesFiltrosSelecionados.includes(pres.cnes)) {
              count += 1;
            }
          }

          // if (
          //   ufFiltrosSelecionados.length ||
          //   municipiosFiltrosSelecionados.length
          // ) {
          //   if (
          //     ufFiltrosSelecionados.includes(sol.uf) &&
          //     municipiosFiltrosSelecionados.includes(sol.municipio)
          //   ) {
          //     count += 1;
          //   }
          // }
          return !!count;
        }
      );
    }
  }

  addFilter(data, tipo) {
    if (!data) {
      return;
    }
    this.revelarConteudo();

    const filtro = {
      tipo,
      data,
    };

    if (!this.filtrosSelecionados.includes(filtro)) {
      this.filtrosSelecionados.push(filtro);
    }

    this.filter();
  }

  async openCalendar(field) {
    if (!this.dtInicio || !this.dtFim) {
      const options: CalendarModalOptions = {
        id: field,
        pickMode: "single",
        title: "Selecione as datas desejadas",
        doneLabel: "",
        closeLabel: "",
        autoDone: true,
        canBackwardsSelected: true,
        step: 12,
        weekdays: ["D", "S", "T", "Q", "Q", "S", "S"],
        weekStart: 0,
      };

      const modal = await this.modalCtrl.create({
        component: CalendarModal,
        keyboardClose: true,
        cssClass: "modal-calendar",
        componentProps: { options },
      });

      modal.onDidDismiss().then((event) => {
        this[field] = moment(event.data.string, "YYYY-MM-DD").format(
          "DD/MM/YYYY"
        );
        this.filter();
        return;
      });
      return modal.present();
    } else if (this[field]) {
      this[field] = null;
      await this.filter();
      return;
    }
  }

  async limparFiltro(field, filtro?) {
    if (field === "dtFim" || field === "dtInicio") {
      this[field] = null;
    }

    if (field === "box-filter") {
      this.filtrosSelecionados = filtro;
    }
    this.formatarConteudo(false);
    this.filter();
  }
}
